import { render, staticRenderFns } from "./ItemTableEvents.vue?vue&type=template&id=d877573a"
import script from "./ItemTableEvents.vue?vue&type=script&lang=js"
export * from "./ItemTableEvents.vue?vue&type=script&lang=js"
import style0 from "./ItemTableEvents.vue?vue&type=style&index=0&id=d877573a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports